enum domain {
	default = '/',
	acquisition = '/acquisition',
	acquisition_residence = '/acquisition_residence'
}

export default domain
